module.exports = __webpack_public_path__ + "img/modernSquash@2x.cc52d765.png";